import React from 'react';
import classNames from 'classnames';

import { useIntl } from '../../../util/reactIntl';

import css from './TrustBadges.module.css';

const IconShield = props => (
  <svg
    className={props.className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M10 2 3 5v5c0 4 2.95 6.74 7 8 4.05-1.26 7-4 7-8V5l-7-3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconTruck = props => (
  <svg
    className={props.className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M2 5h10v9H2zM12 8h4l2 3v3h-6zM5.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM14.5 17a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const IconStar = props => (
  <svg
    className={props.className}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="m10 2 2.47 5.01 5.53.8-4 3.9.94 5.5L10 14.6l-4.94 2.6.94-5.5-4-3.9 5.53-.8z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

const BADGES = [
  { key: 'securePayment', Icon: IconShield, labelId: 'ListingPage.trustBadgeSecurePayment' },
  { key: 'insuredShipping', Icon: IconTruck, labelId: 'ListingPage.trustBadgeInsuredShipping' },
  { key: 'reliableRatings', Icon: IconStar, labelId: 'ListingPage.trustBadgeReliableRatings' },
];

/**
 * Three marketing promises — secure payment, insured shipping, and
 * reliable ratings. Static informational badges (icon + label), not
 * navigation. Reused on the ListingPage (below the Buy now button)
 * and in the FooterContainer payment row.
 *
 * @returns {JSX.Element}
 */
const TrustBadges = props => {
  // `borderless` strips the bottom divider — used where the badges
  // sit inside a section that already owns its own separator (e.g.
  // the EditListing Frakt step, where the Bring notice above acts
  // as the visual hand-off).
  const { borderless } = props || {};
  const intl = useIntl();

  return (
    <div className={classNames(css.root, { [css.borderless]: borderless })}>
      {BADGES.map(({ key, Icon, labelId }) => (
        <div key={key} className={css.badge}>
          <span className={css.iconWrapper}>
            <Icon className={css.icon} />
          </span>
          <p className={css.label}>{intl.formatMessage({ id: labelId })}</p>
        </div>
      ))}
    </div>
  );
};

export default TrustBadges;
